import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductLinksDictionary } from 'ish-core/models/product-links/product-links.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

/**
 * The Product Links Component
 *
 * Collects all types of product links and prepares their rendering.
 * Product links can be displayed as product list (uses {@link ProductLinkListComponent}) or product carousel (uses  {@link ProductLinksCarouselComponent}).
 * For the carousel swiper is used.
 *
 * @example
 * <ish-product-links></ish-product-links>
 */
@Component({
  selector: 'ish-product-links',
  templateUrl: './product-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLinksComponent implements OnInit, OnDestroy {
  links$: Observable<ProductLinksDictionary>;
  triggerCount = 1;
  private destroy$ = new Subject<void>();
  constructor(
    private context: ProductContextFacade,
    private gtmFacade: GoogleTagManagerFacade,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    this.links$ = this.context.select('links');
    this.links$.pipe(takeUntil(this.destroy$)).subscribe(item => {
      const gtmProduct: ProductView[] = item?.crossselling?.products
        .map((data: string) => data.split(',').map((sku: string) => ({ sku })))
        .flat();
      this.gtmFacade.setupIntersectionObserverForGTMEvent(
        this.elementRef.nativeElement,
        gtmProduct,
        this.triggerCount,
        'view_item_list'
      );
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
